import api from "../../api/index";

const developerkey = `${process.env.VUE_APP_BASE_URI}/enterprise/developer`;
const refreshdeveloperkey = `${process.env.VUE_APP_BASE_URI}/enterprise/developer/refresh`;

const getDefaultState = () => {
  return {
    status: "",
    developerkey: [],
  };
};

const state = getDefaultState();

const getters = {
  developerkey: (state) => state.developerkey,
};
const actions = {
  async setupDeveloperAccount({ commit }, developermail) {
    commit("setupdeveloperaccount_request");
    const res = await api.put(developerkey, developermail);
    if (res.data.status === "success") {
      commit("setupdeveloperaccount_success", res.data);
    }
    return res;
  },

  async fetchDeveloperKeys({ commit }) {
    commit("fetchdeveloperkeys_request");
    const res = await api.get(developerkey);
    if (res.data.status === "success") {
      commit("fetchdeveloperkeys_success", res.data.dev);
    }
    return res;
  },

  async refreshDeveloperKeys({ commit }) {
    commit("refreshdeveloperkeys_request");
    const res = await api.get(refreshdeveloperkey);
    if (res.data.status === "success") {
      commit("refreshdeveloperkeys_success", res.data.dev);
    }
    return res;
  },

  async resetDeveloperkeyState({ commit }) {
    await commit("resetdeveloperkeystate_success");
  },
};

const mutations = {
  setupdeveloperaccount_request: (state) => (state.status = "loading"),
  setupdeveloperaccount_success: (state, developerkey) => {
    state.status = "success";
    state.developerkey = developerkey;
  },
  fetchdeveloperkeys_request: (state) => (state.status = "loading"),
  fetchdeveloperkeys_success: (state, developerkey) => {
    state.status = "success";
    state.developerkey = developerkey;
  },
  refreshdeveloperkeys_request: (state) => (state.status = "loading"),
  refreshdeveloperkeys_success: (state, developerkey) => {
    state.status = "success";
    state.developerkey = developerkey;
  },
  resetdeveloperkeystate_success: (state) =>
    Object.assign(state, getDefaultState()),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
